module.exports = __webpack_public_path__ + "img/fleche-tiret-1.33db46b9.png";